import { API, APIObject } from '@/shared/plugins/Api/API'
import _omit from 'lodash/omit'
import { SnapshotTimeTravel } from './SnapshotTimeTravel'

class SnapshotTimeTravelCollection extends APIObject {
  constructor (options) {
    super('DM', options)
    this.currentSnapshotId = options.current_snapshot_id

    this.history = options.history
      ? options.history
        .map(h => new SnapshotTimeTravel(h, this)).filter(i => i)
      : []
  }

  _filter (object) {
    const obj = _omit(super._filter(object), [
      '_id',
      '__socketId',
      'created_at',
      'updated_at',
      'created_by',
      'updated_by'
    ])
    return obj
  }
}

class SnapshotTimeTravelCollections extends API {
  async list (params = {}) {
    const snapshots = await this.request({
      method: 'get',
      url: `v4/databases/${params.databaseId}/tables/${params.tableId}/time-travel`
    })
    return await new SnapshotTimeTravelCollection(snapshots)

    // Mock data in case if dev is not working
    // const timeTravelHistory = require('./mock_snapshot.json')
    // const collection = new SnapshotTimeTravelCollection(timeTravelHistory)
    // return collection
  }
}

export default SnapshotTimeTravelCollections
export {
  SnapshotTimeTravelCollection,
  SnapshotTimeTravelCollections
}
